import {Button, Callout, FormGroup, Intent} from "@blueprintjs/core";
import {observer} from "mobx-react";
import * as React from "react";

import {DeleteButton} from "../../atoms/buttons/buttons";
import {ValidatedInputText} from "../../molecules/validated-input-text/validated-input-text";
import {AdminBreadcrumb} from "../../organisms/admin-breadcrumb/admin-breadcrumb";
import {DeleteDialog} from "../../organisms/delete-dialog/delete-dialog";
import {SlugListEditor} from "../../organisms/slug-list-editor/slug-list-editor";
import {AppLayout} from "../../templates/app-layout/app-layout";
import {DocumentGroupEditPageStore} from "./document-group-edit-page-store";

@observer
export class DocumentGroupEditPage extends React.Component<
    {
        pageStore: DocumentGroupEditPageStore;
    },
    {}
> {
    public render() {
        return (
            <AppLayout
                breadcrumb={
                    <AdminBreadcrumb
                        factory={(builder) =>
                            builder.documentGroupList().custom("ドキュメントグループ編集").build()
                        }
                    />
                }
            >
                {this.props.pageStore.lackedSlugs.length > 0 && (
                    <Callout intent={Intent.WARNING}>
                        無効なスラッグは無視されました:{" "}
                        {this.props.pageStore.lackedSlugs.join(", ")}
                    </Callout>
                )}

                <div style={{marginTop: "20px", width: "400px"}}>
                    <FormGroup label="名称">
                        <ValidatedInputText
                            placeholder="グループ名称"
                            value={this.props.pageStore.title}
                            validationResult={this.props.pageStore.titleValidationResult}
                            onChangeValue={this.props.pageStore.setTitle}
                        />
                    </FormGroup>

                    <FormGroup label="Slug">
                        <ValidatedInputText
                            placeholder="スラッグ"
                            value={this.props.pageStore.key}
                            validationResult={this.props.pageStore.keyValidationResult}
                            onChangeValue={() => undefined}
                            readOnly={true}
                        />
                    </FormGroup>

                    <FormGroup label="ドキュメント">
                        <SlugListEditor
                            slugs={this.props.pageStore.slugs}
                            onChange={this.props.pageStore.setSlugs}
                        />
                    </FormGroup>

                    <div style={{display: "flex", gap: "8px"}}>
                        <Button
                            onClick={this.props.pageStore.saveAndRefresh}
                            loading={this.props.pageStore.isSaving}
                            icon="floppy-disk"
                            disabled={!this.props.pageStore.canSave}
                        >
                            保存
                        </Button>
                        <DeleteButton
                            onClick={() => this.props.pageStore.confirmDeleteDocumentGroup()}
                        >
                            削除
                        </DeleteButton>
                    </div>
                </div>
                <DeleteDialog />
            </AppLayout>
        );
    }
}
